import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Superheader.css";
import ProgressLoader from "../Loader/ProgressLoader";

const Superheader = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);

  // Fetch on mount
  useEffect(() => {    
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const { data } = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_SuperHeader_Slogan"
      );
      if (Array.isArray(data)) {
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Rotate text
  useEffect(() => {
    if (fetchedData.length === 0) return;

    const interval = setInterval(() => {
      setCurrentLineIndex((i) => (i + 1) % fetchedData.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [fetchedData.length]);

  const currentText = fetchedData[currentLineIndex]?.name;

  return (
    <div className="superheader-container d-flex justify-content-center align-items-center">
      {fetchedData.length > 0 ? (
        <p className="superheader-text">{currentText}&nbsp;</p>
      ) : (
        <div className="superheader-placeholder">
          <ProgressLoader />
        </div>
      )}
    </div>
  );
};

export default Superheader;
